export const M = {
  bg: "#07080A",
  deep: "#0B0D11",
  surface: "#101319",
  surface2: "#151A22",
  border: "#232A35",
  ink: "#F2F5F9",
  muted: "#9AA6B6",
  dim: "#5F6B7A",
  ok: "#5FE3A1",
  warn: "#FFC46B",
  danger: "#FF6B6B",
};
